import React, { Component } from "react";
import { withRouter } from "react-router";

import {
  FormGroup,
  Row,
  Col,
  Label,
  Input,
  Button,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  FormFeedback,
} from "reactstrap";
import withReactContent from "sweetalert2-react-content";
import api from "../../utils/axiosApi";
import { Toast } from "../../utils/sweetalert";

import {
  emailSchema,
  nameSchema,
  passwordSchema,
} from "../../utils/validateForm";

class Forms extends Component {
  constructor(props) {
    super(props);
    const { id } = props.match.params;
    if (id) {
      const data = props.location.state;
      this.state = {
        id,
        name: data.name,
        email: data.email,
        password: "",
        newPassword: "",
        repassword: "",
        errors: {
          name: false,
          email: false,
          password: false,
          newPassword: false,
        },
      };
    } else {
      this.state = {
        name: "",
        email: "",
        password: "",
        newPassword: "",
        repassword: "",
        errors: {
          name: false,
          email: false,
          password: false,
          newPassword: false,
        },
      };
    }
  }
  handleChange = (e) => {
    const value = e.target.value.toLowerCase();
    this.setState({ [e.target.name]: value });
  };

  handleChangePassword = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    debugger
    const MySwal = withReactContent(Toast);
    const emailValidation = emailSchema.validate(this.state.email);
    const nameValidation = nameSchema.validate(this.state.name);
    const repasswordValidation = passwordSchema.validate(
      this.state.newPassword
    );
    let newStateError = { ...this.state.errors };
    if (emailValidation.error) {
      newStateError = { ...newStateError, email: "*Email No Valido" };
    }
    if (nameValidation.error) {
      newStateError = { ...newStateError, name: "*Password No Valida" };
    }
    if (
      repasswordValidation.error ||
      this.state.newPassword !== this.state.repassword
    ) {
      newStateError = { ...newStateError, newPassword: "*Email No Valido" };
    }
    this.setState({ errors: newStateError });
    if (
      emailValidation.error ||
      nameValidation.error ||
      repasswordValidation.error
    ) {
      return;
    }
    try {
      const respdb = await api.put(`/backoffice/users/${this.state.id}/`, {
        name: this.state.name,
        email: this.state.email,
        newPassword: this.state.newPassword,
      });
      if (respdb.data.error) {
        await MySwal.fire({
          title: <p style={{ fontSize: "1.5rem" }}>El password no coincide</p>,
          icon: "error",
        });
        return;
      }
      //this.props.history.push('/admin/VerAdmins')
      await MySwal.fire({
        title: (
          <p style={{ fontSize: "1.5rem" }}>
            Actualizado correctamente Exitosamente
          </p>
        ),
        icon: "success",
      });
    } catch (error) {
      await MySwal.fire({
        title: (
          <p style={{ fontSize: "1.5rem" }}>Parece que hubo un error...</p>
        ),
        icon: "error",
      });
      //console.log(error)
    }
  };
  handleValidateEmail = (e) => {
    const validation = emailSchema.validate(this.state.email);
    if (validation.error) {
      this.setState({ errors: { ...this.state.errors, email: true } });
    } else {
      this.setState({ errors: { ...this.state.errors, email: false } });
    }
  };
  handleValidateName = (e) => {
    const validation = nameSchema.validate(this.state.name);
    if (validation.error) {
      this.setState({ errors: { ...this.state.errors, name: true } });
    } else {
      this.setState({ errors: { ...this.state.errors, name: false } });
    }
  };
  handleValidatePassword = (e) => {
    const validation = passwordSchema.validate(this.state.password);
    if (validation.error) {
      this.setState({ errors: { ...this.state.errors, password: true } });
    } else {
      this.setState({ errors: { ...this.state.errors, password: false } });
    }
  };
  handleValidateNewPassword = (e) => {
    const validation = passwordSchema.validate(this.state.newPassword);
    if (validation.error || this.state.repassword !== this.state.newPassword) {
      this.setState({ errors: { ...this.state.errors, newPassword: true } });
    } else {
      this.setState({ errors: { ...this.state.errors, newPassword: false } });
    }
  };
  render() {
    return (
      <>
        <div className="content">
          <Row>
            <Col md="12">
              <Card>
                <CardHeader>
                  <CardTitle tag="h4">Editar Usuario</CardTitle>
                </CardHeader>
                <CardBody>
                  <form onSubmit={this.handleSubmit}>
                    <FormGroup>
                      <Label for="name">Nombre</Label>
                      <Input
                        onChange={this.handleChange}
                        onBlur={this.handleValidateName}
                        invalid={this.state.errors.name}
                        value={this.state.name}
                        type="text"
                        name="name"
                        id="name"
                        placeholder="Introduzca el nombre"
                      />
                      <FormFeedback>El nombre no es Valido</FormFeedback>
                    </FormGroup>
                    <FormGroup>
                      <Label for="email">Correo</Label>
                      <Input
                        onChange={this.handleChange}
                        onBlur={this.handleValidateEmail}
                        invalid={this.state.errors.email}
                        value={this.state.email}
                        type="email"
                        name="email"
                        id="email"
                        placeholder="Introduzca el Email"
                      />
                      <FormFeedback>El correo no es Valido</FormFeedback>
                    </FormGroup>
                    <Row>
                      <Col className="pr-md-1" md="6">
                        <FormGroup>
                          <Label for="newPassword">Nueva Contraseña</Label>
                          <Input
                            onChange={this.handleChangePassword}
                            onBlur={this.handleValidateNewPassword}
                            invalid={this.state.errors.newPassword}
                            type="password"
                            name="newPassword"
                            id="newPassword"
                            placeholder="Min 8 caracteres"
                          />
                          <FormFeedback>
                            la contraseña no es valida
                          </FormFeedback>
                        </FormGroup>
                      </Col>
                      <Col className="pl-md-1" md="6">
                        <FormGroup>
                          <Label for="repassword">Repita la Contraseña</Label>
                          <Input
                            onChange={this.handleChangePassword}
                            onBlur={this.handleValidateNewPassword}
                            invalid={this.state.errors.newPassword}
                            type="password"
                            name="repassword"
                            id="repassword"
                            placeholder="Vuelva a ingresar la contraseña"
                          />
                        </FormGroup>
                      </Col>
                    </Row>

                    <Button color="primary" type="submit">
                      Actualizar
                    </Button>
                  </form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </>
    );
  }
}

export default withRouter(Forms);
